module.exports = __webpack_public_path__ + "ccb55f20d28bd2b96dc15e3e87578cdb.pdf";